export type SpecialColor = 'blue' | 'orange';

export function resolveColorKey(input?: string): SpecialColor | undefined {
  const text = input?.toLowerCase() ?? '';

  if (text.includes('blue')) return 'blue';
  if (text.includes('orange')) return 'orange';

  return undefined;
}
